<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">校区题库</span>
    <div style="margin-top:20px;">
      <el-button
        icon="el-icon-plus"
        size="mini"
        type="primary"
        @click="add_questions"
        v-if="userInfo.CreateProblem"
      >
        添加题库
      </el-button>
    </div>

    <el-table :data="tableData" border stripe>
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="Name" label="名称"></el-table-column>
      <el-table-column prop="introduce" label="科目" min-width="30">
        <template slot-scope="scope">
          <el-tag size="mini">{{ scope.row.Subject }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-popover placement="top-start" trigger="hover">
            <el-alert
              title="分配试卷后，题目不可修改，请确认试卷内题目无误后分配！"
              type="error"
              show-icon
            >
            </el-alert>
            <el-button
              type="primary"
              size="mini"
              @click="distribution_campus(scope.row.Id)"
              v-if="button_principal"
            >
              分配校区
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="assign_classes_button(scope.row.Id)"
              style="margin-right:12px;"
            >
              分配班级
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="distribution_teacher(scope.row.Id)"
              v-if="button_teacher"
              style="margin-top:12px;margin-left:0px;"
            >
              分配老师
            </el-button>

            <el-button
              slot="reference"
              type="success"
              icon="el-icon-d-arrow-right"
              size="mini"
              style="margin:0px 12px;"
            >
              分配
            </el-button>
          </el-popover>

          <el-button
            type="primary"
            icon="el-icon-folder-opened"
            size="mini"
            @click="question_management(scope.row)"
          >
            试题管理
          </el-button>
          <el-button
            type="warning"
            icon="el-icon-edit"
            size="mini"
            @click="edit_question(scope.row, scope.$index)"
          >
            修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加题库弹框 -->
    <el-dialog
      :title="form.id ? '修改题库' : '添加题库'"
      :visible.sync="dialog_question"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="form_ref"
        :model="form"
        :rules="rules"
        label-width="56px"
        class="login_from"
        label-position="right"
      >
        <el-form-item label="名称" prop="name" style="width:60%;">
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <el-form-item label="科目" prop="subject" style="width:50%;">
          <el-select v-model="form.subject" placeholder="请选择科目">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_question = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="add_dialog" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 试题管理弹框 -->
    <el-dialog
      title="试题管理"
      fullscreen
      :visible.sync="dialog_question_management"
      :close-on-click-modal="false"
    >
      <div>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="add_test_questions"
        >
          添加试题
        </el-button>
      </div>

      <el-table :data="question_tableData" border stripe>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column label="题型">
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.Type == 'SingleChoiceQuestion'">
              单选题
            </el-tag>
            <el-tag size="mini" v-if="scope.row.Type == 'MultiChoiceQuestion'">
              多选题
            </el-tag>
            <el-tag size="mini" v-if="scope.row.Type == 'TrueFalseQuestion'">
              判断题
            </el-tag>
            <el-tag size="mini" v-if="scope.row.Type == 'AnswerQuestion'">
              问答题
            </el-tag>
            <el-tag size="mini" v-if="scope.row.Type == 'ScratchQuestion'">
              Scratch
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="introduce" label="内容">
          <template slot-scope="scope">
            <div v-html="scope.row.Describe" class="vhtml_img"></div>
          </template>
        </el-table-column>
        <el-table-column label="答案">
          <template slot-scope="scope">
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'SingleChoiceQuestion'"
              v-html="
                scope.row.ExtraField.SingleChoiceField.Choices[
                  scope.row.ExtraField.SingleChoiceField.Answer
                ]
              "
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'MultiChoiceQuestion'"
              v-html="
                scope.row.ExtraField.MultiChoiceField.Choices[
                  scope.row.ExtraField.MultiChoiceField.Answer[0]
                ]
              "
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'MultiChoiceQuestion'"
              v-html="
                scope.row.ExtraField.MultiChoiceField.Choices[
                  scope.row.ExtraField.MultiChoiceField.Answer[1]
                ]
              "
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'MultiChoiceQuestion'"
              v-html="
                scope.row.ExtraField.MultiChoiceField.Choices[
                  scope.row.ExtraField.MultiChoiceField.Answer[2]
                ]
              "
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'MultiChoiceQuestion'"
              v-html="
                scope.row.ExtraField.MultiChoiceField.Choices[
                  scope.row.ExtraField.MultiChoiceField.Answer[3]
                ]
              "
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'TrueFalseQuestion'"
              v-html="scope.row.ExtraField.TrueFalseField.Answer"
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'AnswerQuestion'"
              v-html="scope.row.ExtraField.AnswerField.Answer"
            ></div>
            <div
              class="vhtml_img"
              v-if="scope.row.Type == 'ScratchQuestion'"
              v-html="scope.row.ExtraField.ScratchField.Answer"
            ></div>
          </template>
        </el-table-column>
        <el-table-column label="答案解析">
          <template slot-scope="scope">
            <div v-html="scope.row.AnswerAnalysis" class="vhtml_img"></div>
          </template>
        </el-table-column>
        <el-table-column prop="Subject" label="科目"> </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="el-icon-edit"
              size="mini"
              @click="edit_form_question(scope.row)"
            >
              修改
            </el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="delete_question(scope.row, scope.$index)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 添加试题弹框 -->
    <el-dialog
      :title="form_questions.id ? '修改试题' : '添加试题'"
      :visible.sync="dialog_add_test_questions"
      :close-on-click-modal="false"
      @close="dialog_close"
      width="80%"
      v-if="form_questions_type"
    >
      <div class="questions">
        <p><span>*</span>科目类型</p>
        <el-select v-model="form_questions.subject" placeholder="请选择科目">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="questions">
        <p>
          <span>*</span>试题类型
          <span
            v-if="form_questions.id"
            style="color:red;margin-left:12px;font-size:12px;"
          >
            <i class="el-icon-warning" />
            类型不允许修改！
          </span>
        </p>
        <el-radio
          v-model="form_questions.radio_type"
          label="单选题"
          :disabled="form_questions.id ? true : false"
        >
          单选题
        </el-radio>
        <el-radio
          v-model="form_questions.radio_type"
          label="多选题"
          :disabled="form_questions.id ? true : false"
        >
          多选题
        </el-radio>
        <el-radio
          v-model="form_questions.radio_type"
          label="判断题"
          :disabled="form_questions.id ? true : false"
        >
          判断题
        </el-radio>
        <el-radio
          v-model="form_questions.radio_type"
          label="问答题"
          :disabled="form_questions.id ? true : false"
        >
          问答题
        </el-radio>
        <el-radio
          v-model="form_questions.radio_type"
          label="Scratch"
          :disabled="form_questions.id ? true : false"
        >
          Scratch
        </el-radio>
      </div>

      <div class="questions">
        <p><span>*</span>分数</p>
        <el-input
          style="width:300px;"
          placeholder="请输入分数"
          type="number"
          v-model="form_questions.score"
        ></el-input>
      </div>

      <div class="questions" v-if="form_questions.radio_type == 'Scratch'">
        <p><span>*</span>上传Scratch模版</p>
        <el-upload
          ref="removeUpload"
          class="upload-demo"
          :action="uploadURL"
          :on-success="upload_success"
          :on-remove="upload_remove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
          style="width:100%;"
        >
          <el-button size="mini" type="primary">上传</el-button>
        </el-upload>
      </div>

      <el-collapse v-model="activeName" accordion @change="collapse_change">
        <!-- <el-collapse-item name="试题题目">
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题题目
          </template>
          <div class="questions">
            <div>
              <quillA
                v-if="activeName == '试题题目' ? true : false"
                @input="input_emit"
                v-model="form_questions.name"
              ></quillA>
            </div>
          </div>
        </el-collapse-item> -->
        <el-collapse-item name="试题内容">
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题内容
          </template>
          <div class="questions">
            <quillA
              v-if="activeName == '试题内容' ? true : false"
              @input="input_emit"
              v-model="form_questions.describe"
            ></quillA>
          </div>
        </el-collapse-item>
        <el-collapse-item name="答案解析">
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 答案解析
          </template>
          <div class="questions">
            <quillA
              v-if="activeName == '答案解析' ? true : false"
              @input="input_emit"
              v-model="form_questions.answerAnalysis"
            ></quillA>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="A"
          v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
        >
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题选项 A
          </template>

          <div
            class="questions"
            v-if="form_questions.radio_type == '单选题' || '多选题'"
          >
            <quillA
              v-if="activeName == 'A' ? true : false"
              @input="input_emit"
              v-model="form_questions.choices[0]"
            ></quillA>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="B"
          v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
        >
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题选项 B
          </template>

          <div
            class="questions"
            v-if="form_questions.radio_type == '单选题' || '多选题'"
          >
            <quillA
              v-if="activeName == 'B' ? true : false"
              @input="input_emit"
              v-model="form_questions.choices[1]"
            ></quillA>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="C"
          v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
        >
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题选项 C
          </template>

          <div
            class="questions"
            v-if="form_questions.radio_type == '单选题' || '多选题'"
          >
            <quillA
              v-if="activeName == 'C' ? true : false"
              @input="input_emit"
              v-model="form_questions.choices[2]"
            ></quillA>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="D"
          v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
        >
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题选项 D
          </template>

          <div
            class="questions"
            v-if="form_questions.radio_type == '单选题' || '多选题'"
          >
            <quillA
              v-if="activeName == 'D' ? true : false"
              @input="input_emit"
              v-model="form_questions.choices[3]"
            ></quillA>
          </div>
        </el-collapse-item>
        <el-collapse-item
          name="问答题"
          v-if="form_questions.radio_type == '问答题' ? true : false"
        >
          <template slot="title">
            <span style="color:red;margin-right:4px;">*</span> 试题答案
          </template>
          <div class="questions">
            <quillA
              v-if="activeName == '问答题' ? true : false"
              @input="input_emit"
              v-model="form_questions.blanks"
            ></quillA>
          </div>
        </el-collapse-item>
      </el-collapse>

      <div
        class="questions"
        style="margin-top: 30px;"
        v-if="form_questions.radio_type == '问答题' ? false : true"
      >
        <p><span>*</span>试题答案</p>
        <div v-if="form_questions.radio_type == '单选题'">
          <el-radio v-model="form_questions.radio_answer" :label="0">
            A
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="1">
            B
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="2">
            C
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="3">
            D
          </el-radio>
        </div>
        <div v-if="form_questions.radio_type == '多选题'">
          <el-checkbox-group v-model="form_questions.checkList">
            <el-checkbox :label="0">A</el-checkbox>
            <el-checkbox :label="1">B</el-checkbox>
            <el-checkbox :label="2">C</el-checkbox>
            <el-checkbox :label="3">D</el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="form_questions.radio_type == '判断题'">
          <el-radio v-model="form_questions.radio_judge" :label="true">
            A. 正确
          </el-radio>
          <el-radio v-model="form_questions.radio_judge" :label="false">
            B. 错误
          </el-radio>
        </div>
        <div v-if="form_questions.radio_type == 'Scratch'">
          <el-upload
            ref="removeUpload"
            class="upload-demo"
            :action="uploadURL"
            :on-success="upload_success_answer"
            :on-remove="upload_remove_answer"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            style="width:100%;"
          >
            <el-button size="mini" type="primary">上传</el-button>
          </el-upload>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_add_test_questions = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="determine_test_questions" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 分配老师弹框 -->
    <el-dialog
      title="分配老师"
      :visible.sync="teacher_dialog"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-select
        v-model="teacher_form.username"
        clearable
        placeholder="请选择老师"
        style="width: 50%;"
      >
        <el-option
          v-for="item in teacher_data"
          :key="item.Name"
          :label="item.Name"
          :value="item.Name"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="teacher_dialog = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="teacher_dialog_is" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 分配校区弹框 -->
    <el-dialog
      title="分配校区"
      :visible.sync="campus_dialog"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-select
        v-model="campus_form.schoolId"
        clearable
        placeholder="请选择校区"
        style="width: 50%;"
      >
        <el-option
          v-for="item in campus_data"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="campus_dialog = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="campus_dialog_is" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>

    <!-- 分配班级弹框 -->
    <el-dialog
      title="分配班级"
      :visible.sync="assign_classes"
      :close-on-click-modal="false"
      width="50%"
    >
      <div>
        <el-radio-group v-model="class_form.sheetType">
          <el-radio label="EXAM"> 考试 </el-radio>
          <el-radio label="HOMEWORK"> 作业 </el-radio>
        </el-radio-group>
      </div>
      <div style="margin-top:20px;">
        <el-select
          v-model="class_form.classId"
          clearable
          placeholder="请选择班级"
          style="width: 50%;"
        >
          <el-option
            v-for="item in class_data"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="assign_classes = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="assign_classes_submit" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import {
  post_question_choice_api,
  delete_question,
  post_question_sheet_api,
  get_question_sheet_api,
  put_question_sheet_api,
  post_add_question_api,
  put_choice_questions_api,
  post_multiple_choice_api,
  put_multiple_choice_api,
  post_true_false_api,
  put_true_false_api,
  post_answer_question_api,
  put_answer_question_api,
  post_class_sheet_api,
  put_school_sheet_api,
  post_scratch_api,
  put_scratch_api,
  put_teacher_sheet_api,
} from "@/api/question.js";
import { get_class_api } from "@/api/home.js";
import { upload_resources_image_api } from "@/api/resources.js";
import { getSchool, get_add_principal } from "@/api/admin.js";
import quillA from "./components/quill_editor_A.vue";
import loading from "@/components/loading.vue";
export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    quillA,
    loading,
  },
  data() {
    return {
      rules: {
        // 验证用户名是否合法
        name: [{ required: true, message: "请输入题库名称", trigger: "blur" }],
        // 验证密码是否合法
        subject: [{ required: true, message: "请选择科目", trigger: "blur" }],
      },
      dialog_question: false,
      campus_dialog: false,
      teacher_dialog: false,
      dialog_question_management: false,
      dialog_add_test_questions: false,
      tableData: [],
      question_tableData: [],
      form: { name: "", subject: "" },
      form_questions: {
        score: "", //分数
        name: "", //试题题目
        describe: "", //内容
        answerAnalysis: "", //答案解析
        blanks: "", //简答题
        choices: [],
        radio_type: "单选题", //题目类型
        radio_answer: 0,
        radio_judge: true,
        checkList: [],
        subject: "", //选择科目
        material: "", //scratch模版ID
        scratch_answer: "", //scratch答案
      },
      options: [
        {
          value: "C++",
          label: "C++",
        },
        {
          value: "Python",
          label: "Python",
        },
        {
          value: "Scratch",
          label: "Scratch",
        },
      ],
      class_data: [],
      campus_data: [],
      teacher_data: [],
      sheetName: "",
      form_questions_type: false,
      assign_classes: false,
      class_form: { classId: "", sheetId: "", sheetType: "EXAM" },
      campus_form: { schoolId: "", sheetId: "" },
      teacher_form: { schoolId: "", sheetId: "", username: "" },
      activeName: " ",
      uploadURL: "",
      button_principal: "",
      button_teacher: "",
      loading_ok: "",
      edit_index: "",
    };
  },

  created() {
    this.userInfo.user_role.forEach((res) => {
      if (res.Subject.Name == "ADMIN") {
        this.button_principal = true;
        this.button_teacher = true;
      } else if (res.Subject.Name == "HEADMASTER") {
        this.button_teacher = true;
      }
    });

    this.get_question_sheet();
    this.uploadURL = upload_resources_image_api();
    // 获取校区
    getSchool().then((res) => {
      console.log(res.data);
      this.campus_data = res.data;
    });
  },

  methods: {
    //获取题库
    get_question_sheet() {
      get_question_sheet_api().then((res) => {
        this.loading_ok = false;
        this.tableData = res.data;
      });
    },

    //添加题库按钮
    add_questions() {
      this.form = {};
      if (this.$refs.form_ref !== undefined) {
        this.$refs.form_ref.clearValidate();
      }
      this.dialog_question = true;
    },

    //添加题库框确定
    add_dialog() {
      this.$refs.form_ref.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            put_question_sheet_api(this.form).then((res) => {
              this.tableData.splice(this.edit_index, 1, res.data);
              this.$message.success("修改成功！");
            });
          } else {
            post_question_sheet_api(this.form).then((res) => {
              this.tableData.push(res.data);
              this.$message.success("添加成功！");
            });
          }
          this.dialog_question = false;
        }
      });
    },

    //修改题库
    edit_question(item, i) {
      console.log(i);
      this.edit_index = i;
      this.form.id = item.Id;
      this.form.name = item.Name;
      this.form.subject = item.Subject;
      this.dialog_question = true;
    },

    //修改试题
    edit_form_question(item) {
      console.log(item);

      this.form_questions.id = item.Id;
      this.form_questions.name = item.Name;
      this.form_questions_type = true;
      this.form_questions.name = "";
      this.form_questions.id = item.Id;
      this.form_questions.score = item.Score;
      this.form_questions.answerAnalysis = item.AnswerAnalysis;
      if (item.Type == "SingleChoiceQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.subject = item.Subject;
        this.form_questions.radio_answer =
          item.ExtraField.SingleChoiceField.Answer;
        this.form_questions.choices = item.ExtraField.SingleChoiceField.Choices;
      } else if (item.Type == "MultiChoiceQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "多选题";
        this.form_questions.subject = item.Subject;
        this.form_questions.checkList = item.ExtraField.MultiChoiceField.Answer;
        this.form_questions.choices = item.ExtraField.MultiChoiceField.Choices;
      } else if (item.Type == "TrueFalseQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "判断题";
        this.form_questions.subject = item.Subject;
        this.form_questions.radio_judge = item.ExtraField.TrueFalseField.Answer;
      } else if (item.Type == "AnswerQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "问答题";
        this.form_questions.subject = item.Subject;
        this.form_questions.blanks = item.ExtraField.AnswerField.Answer;
      } else if (item.Type == "ScratchQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "Scratch";
        this.form_questions.subject = item.Subject;
        this.form_questions.material = item.ExtraField.ScratchField.Material;
        this.form_questions.scratch_answer =
          item.ExtraField.ScratchField.Answer;
      }
      this.dialog_add_test_questions = true;
    },

    //删除题库
    delete_question(item, index) {
      console.log(item, index);
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false,
      })
        .then(() => {
          delete_question(item.Name).then(() => {
            this.$message.success("删除成功！");
            this.question_tableData.splice(index, 1);
          });
        })
        .catch(() => {
          this.$message.warning("您已取消操作！");
        });
    },

    //试题管理
    question_management(item) {
      this.sheetName = item.Name;
      this.question_tableData = item.Questions;
      this.dialog_question_management = true;
    },

    //添加试题
    add_test_questions() {
      this.form_questions_type = true;
      this.form_questions = {
        name: "", //试题题目
        describe: "", //内容
        blanks: "", //简答题
        answerAnalysis: "", //答案解析
        choices: [],
        radio_type: "单选题", //题目类型
        radio_answer: 0,
        radio_judge: "正确",
        checkList: [],
        subject: "",
      };
      this.dialog_add_test_questions = true;
    },

    //添加试题弹框确定
    determine_test_questions() {
      var myDate = new Date();
      var a = myDate.getFullYear();
      var b = myDate.getMonth() + 1;
      var c = myDate.getDate();
      var d = myDate.getHours();
      var e = myDate.getMinutes();
      var f = myDate.getSeconds();
      var time = a + "-" + b + "-" + c + " " + d + ":" + e + ":" + f;
      if (!this.form_questions.id) {
        this.form_questions.name = time;
      }
      if (this.form_questions.radio_type == "单选题") {
        let data = {
          score: parseInt(this.form_questions.score),
          name: this.form_questions.name,
          answer: this.form_questions.radio_answer,
          describe: this.form_questions.describe,
          choices: this.form_questions.choices,
          subject: this.form_questions.subject,
          answerAnalysis: this.form_questions.answerAnalysis,
        };

        if (this.form_questions.id) {
          put_choice_questions_api(data).then(() => {
            this.get_question_sheet();
            this.$message.success("修改成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        } else {
          post_question_choice_api(data).then((res) => {
            this.post_add_question();
            this.$message.success("添加成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        }
      } else if (this.form_questions.radio_type == "多选题") {
        let data = {
          score: parseInt(this.form_questions.score),
          name: this.form_questions.name,
          answer: this.form_questions.checkList,
          describe: this.form_questions.describe,
          choices: this.form_questions.choices,
          subject: this.form_questions.subject,
          answerAnalysis: this.form_questions.answerAnalysis,
        };

        if (this.form_questions.id) {
          put_multiple_choice_api(data).then(() => {
            this.get_question_sheet();
            this.$message.success("修改成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        } else {
          post_multiple_choice_api(data).then(() => {
            this.post_add_question();
            this.$message.success("添加成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        }
      } else if (this.form_questions.radio_type == "判断题") {
        let data = {
          score: parseInt(this.form_questions.score),
          name: this.form_questions.name,
          answer: this.form_questions.radio_judge,
          describe: this.form_questions.describe,
          choices: this.form_questions.choices,
          subject: this.form_questions.subject,
          answerAnalysis: this.form_questions.answerAnalysis,
        };

        if (this.form_questions.id) {
          put_true_false_api(data).then(() => {
            this.get_question_sheet();
            this.$message.success("修改成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        } else {
          post_true_false_api(data).then((res) => {
            this.post_add_question();
            this.$message.success("添加成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        }
      } else if (this.form_questions.radio_type == "问答题") {
        let data = {
          score: parseInt(this.form_questions.score),
          name: this.form_questions.name,
          answer: this.form_questions.blanks,
          describe: this.form_questions.describe,
          subject: this.form_questions.subject,
          answerAnalysis: this.form_questions.answerAnalysis,
        };

        if (this.form_questions.id) {
          put_answer_question_api(data).then(() => {
            this.$message.success("修改成功！");
            this.get_question_sheet();
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        } else {
          post_answer_question_api(data).then(() => {
            this.post_add_question();
            this.$message.success("添加成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        }
      } else if (this.form_questions.radio_type == "Scratch") {
        let data = {
          material: this.form_questions.material,
          score: parseInt(this.form_questions.score),
          name: this.form_questions.name,
          answer: this.form_questions.scratch_answer,
          describe: this.form_questions.describe,
          subject: this.form_questions.subject,
          answerAnalysis: this.form_questions.answerAnalysis,
        };

        if (this.form_questions.id) {
          put_scratch_api(data).then(() => {
            this.get_question_sheet();
            this.$message.success("修改成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        } else {
          post_scratch_api(data).then(() => {
            this.post_add_question();
            this.$message.success("添加成功！");
            this.dialog_question_management = false;
            this.dialog_add_test_questions = false;
          });
        }
      }
    },

    //添加试题到题库
    post_add_question() {
      post_add_question_api({
        questionName: this.form_questions.name,
        sheetName: this.sheetName,
      }).then(() => {
        this.get_question_sheet();
      });
    },

    input_emit(item) {
      console.log(item);
    },

    //监听添加试题弹框关闭事件
    dialog_close() {
      this.form_questions_type = false;
    },

    //分配校区按钮
    distribution_campus(id) {
      this.campus_dialog = true;
      this.campus_form.sheetId = id;
    },

    //分配校区弹框确定按钮
    campus_dialog_is() {
      put_school_sheet_api(this.campus_form).then((res) => {
        this.$message.success("分配成功！");
        this.campus_dialog = false;
        this.campus_form.schoolId = "";
        this.campus_form.sheetId = "";
      });
    },

    //分配老师弹框按钮
    distribution_teacher(id) {
      this.teacher_form.sheetId = id;
      this.campus_data.forEach((res) => {
        if (res.Name == this.current) {
          this.teacher_form.schoolId = res.Id;
        }
      });

      this.teacher_dialog = true;
      let data = {
        domain: {
          group: "SCHOOL",
          name: this.current,
        },
        subject: {
          group: "ROLE",
          name: "TEACHER",
        },
      };

      // 获取校区下面的老师
      get_add_principal(data).then((res) => {
        this.teacher_data = res.data;
        console.log(this.teacher_data);
      });
    },

    //分配老师弹框确定按钮
    teacher_dialog_is() {
      put_teacher_sheet_api(this.teacher_form).then(() => {
        this.teacher_form.schoolId = "";
        this.teacher_form.sheetId = "";
        this.teacher_form.username = "";
        this.teacher_dialog = false;
        this.$message.success("分配成功！");
      });
    },

    //分配班级按钮
    assign_classes_button(item) {
      this.class_form.classId = "";
      this.assign_classes = true;
      this.class_form.sheetId = item;
      // 获取班级
      get_class_api(this.current).then((res) => {
        this.class_data = res.data;
      });
    },

    //分配班级弹框确定按钮
    assign_classes_submit() {
      post_class_sheet_api(this.class_form).then(() => {
        this.get_question_sheet();
        this.$message.success("分配成功！");
        this.assign_classes = false;
      });
    },

    collapse_change(v) {
      console.log(v);
    },

    // 上传Scratch模版成功钩子
    upload_success(res) {
      this.form_questions.material = res.Id;
    },

    // 上传Scratch答案成功钩子
    upload_success_answer(res) {
      this.form_questions.scratch_answer = res.Id;
    },

    // 移除Scratch模版钩子
    upload_remove() {
      this.form_questions.material = "";
    },

    upload_remove_answer() {
      this.form_questions.scratch_answer = "";
    },

    // 超出上传文件个数钩子
    handleExceed() {
      this.$message.error("目前仅支持上传单个文件");
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
  }
  .el-table {
    margin-top:15px;
  }

  .questions {
    background:#f8f8f8;
    border:1px solid #f3f3f3;
    padding:16px;
    border-radius:6px;
    margin-bottom:50px;
    p {
      margin-bottom:14px;
      span {
        color:#F56C6C;
        margin-right:4px;
      }
    }
  }
}

>>>.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

>>>.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

>>>.el-date-editor.el-input {
  width: auto;
}

>>>.el-dialog__footer {
  margin-top:0px;
}

>>>.el-radio__label {
  padding-left: 0;
}

.vhtml_img >>> img {
   width: 100px;
}
</style>
